<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">
              {{ $t("progress_report.progress_report_detail") }}
            </h4>
          </div>
        </md-card-header>
        <md-card-content v-if="progressDetail">
          <h2 class="text-lg my-3 text-center">
            {{ progressDetail.title }}
          </h2>

          <div class="md-layout items-center">
            <div class="md-layout-item md-size-100 mb-3">
              <span
                :class="getClassStatus(progressDetail.status)"
                class="bg-[#F6C3FF] p-2 rounded font-normal"
              >
                {{ generateStatusReport(progressDetail.status) }}
              </span>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <span class="font-normal">
                {{ $t("submitted_report.report_type") }}:
              </span>
              {{ generateTypeReport(progressDetail.report_type) }}
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <span class="font-normal">
                Report template:
              </span>
              {{ progressDetail.report_template }}
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <div v-if="isViewOnly">
                <span class="font-normal"> {{ $t("common.term") }}: </span>
                {{ progressDetail.term && progressDetail.term.name }}
              </div>
              <md-field v-else>
                <label> {{ $t("progress_report.term") }}</label>
                <md-select
                  id="term"
                  name="term"
                  v-model="termSelect.value"
                  :disabled="isDisable || isViewOnly"
                >
                  <md-option
                    v-for="option in termSelect.options"
                    :key="option.id + option.name"
                    :value="option.id"
                    >{{ $t(option.name) }}
                  </md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <div v-if="!isStudentOrFamily">
                <span class="font-normal">
                  {{ $t("progress_report.the_last_inputter") }}:
                </span>
                {{
                  progressDetail.inputter && progressDetail.inputter.full_name
                }}
              </div>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <div
                v-if="
                  progressDetail.type_sending_model !== 'No-review' &&
                    !isStudentOrFamily
                "
              >
                <span class="font-normal">
                  {{ $t("progress_report.the_last_reviewer") }}:
                </span>
                {{
                  progressDetail.reviewer && progressDetail.reviewer.full_name
                }}
              </div>
            </div>
          </div>

          <TemplateProgressReport
            :form-props="progressDetail"
            :reportTemplate="progressDetail.report_template"
            :term-id="termSelect.value"
            :isViewOnly="isViewOnly"
            :isDisable="isDisable"
            :generateVietnamese="generateVietnamese"
            ref="templateProgressReport"
          />

          <div
            v-if="!isViewOnly"
            class="md-layout-item md-size-100 flex justify-center mt-6"
          >
            <md-button
              v-if="!isDisable"
              :disabled="!termSelect.value"
              class="md-success mx-2"
              @click="saveForm"
              >{{ $t("common.save") }}
            </md-button>
            <md-button
              :disabled="!termSelect.value"
              v-if="progressDetail.status !== 'Pending'"
              class="md-success mx-2"
              @click="saveAndReview"
              >{{ $t(setContentSendBtn(progressDetail)) }}
            </md-button>
          </div>
        </md-card-content>
        <div v-else>
          <no-data-found></no-data-found>
        </div>
      </md-card>
    </div>
  </div>
</template>
<script>
import { getId, Message } from "@/helpers/utils";
import { service_names } from "@/constants/Services";
import {
  getClassStatus,
  SENDING_MODE,
  setContentSendBtn,
  setStatusSendEmail,
  STATUS
} from "@/pages/ProgressReport/Components/utils";
import { mapGetters } from "vuex";
import { ReportTemplates, StatusReports } from "../../../../constants/Report";
import TemplateProgressReport from "../../Components/Templates";
import { generateStatusReport } from "@/helpers/text-helper";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";
import { generateTypeReport } from "../../../../helpers/text-helper";

export default {
  components: {
    TemplateProgressReport
  },
  data() {
    return {
      setContentSendBtn,
      getClassStatus,
      STATUS,
      generateStatusReport,
      progressDetail: {},
      termSelect: {
        value: "",
        options: []
      }
    };
  },
  computed: {
    ...mapGetters("user", { userInfo: "info", useRole: "role" }),
    isStudentOrFamily() {
      return hasValidRole(this.useRole, [Role.Student, Role.Family]);
    },
    progressId() {
      return this.$route.params.id;
    },
    authorized() {
      return this.userInfo?.inputterOrReviewDetail?.authorized;
    },
    isDisable() {
      return (
        this.progressDetail.status === StatusReports.Official ||
        this.progressDetail.status === StatusReports.Pending
      );
    },
    isViewOnly() {
      return this.authorized !== "Inputter";
    },
    generateVietnamese() {
      const isDisplay =
        this.progressDetail.report_template === ReportTemplates.Standard
          ? "block"
          : "hidden";
      return "italic font-mono " + isDisplay;
    },

    pathApiSave() {
      const template = this.progressDetail.report_template;
      return `${service_names.user}/progress-${template}/${getId(
        this.progressDetail
      )}`;
    },
    pathApiSaveAndReview() {
      const template = this.progressDetail.report_template;
      return `${service_names.utility}/export/multiple/${template}-report`;
    }
  },
  watch: {
    progressDetail() {
      this.fetchTerm();
    }
  },
  methods: {
    generateTypeReport,
    initData() {
      this.$axios
        .get(`${service_names.user}/progress/report/${this.progressId}`)
        .then(res => {
          this.progressDetail = res.data;
          console.log("progressDetail: ", res.data);
          this.termSelect.value = getId(res.data.term);
        });
    },

    async fetchTerm() {
      const type =
        this.progressDetail.report_type !== "mid_term"
          ? this.progressDetail.report_type.substr(
              this.progressDetail.report_type.length - 1
            )
          : "";
      const {
        data
      } = await this.$axios.get(
        `${service_names.school}/terms/student/${this.progressDetail.student_id}`,
        { semester_number: type, created_at: "desc" }
      );
      this.termSelect.options = data;
    },

    saveForm() {
      const form = this.$refs.templateProgressReport.buildFormSave(
        "not_validate_all"
      );
      try {
        this.$axios.patch(this.pathApiSave, form).then(() => {
          Message.success(this.$t("common.update_success"));
          this.initData();
        });
      } catch (e) {
        console.log("save error: ", e);
      }
    },

    async saveAndReview() {
      const isValidate = this.$refs.templateProgressReport.checkValidateForm();
      if (!isValidate) return;

      const form = this.$refs.templateProgressReport.buildFormSave(
        "validate_all"
      );
      const status = setStatusSendEmail(form);

      try {
        await this.$axios.patch(this.pathApiSave, {
          ...form,
          status: status
        });

        if (
          form.status === STATUS.OFFICIAL ||
          form.type_sending_model === SENDING_MODE.NO_REVIEW
        ) {
          await this.$axios.post(this.pathApiSaveAndReview, {
            array_progress_id: [getId(this.progressDetail)]
          });
        }
        Message.success(this.$t("common.update_success"));
        this.initData();
      } catch (e) {
        console.log("send email error: ", e);
      }
    }
  },
  created() {
    this.initData();
  }
};
</script>
